import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Lock, SignIn } from "@phosphor-icons/react";
import { useAuth } from "../context/AuthContext";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      nav("/admin");
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === "string" ? d : "Error al iniciar sesión");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-5 py-16">
      <div className="w-full max-w-md bg-[#111111] border border-white/10 p-8" data-testid="admin-login-card">
        <div className="w-12 h-12 border border-[#D97736] flex items-center justify-center text-[#D97736] mb-6">
          <Lock size={22} weight="bold" />
        </div>
        <div className="overline text-[#F5A623] mb-1">Panel de administración</div>
        <h1 className="font-display text-4xl mb-8">Iniciar sesión</h1>

        <form onSubmit={submit} className="space-y-6">
          <div>
            <label className="overline block mb-2">Correo</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full bg-transparent border-b border-white/20 focus:border-[#D97736] outline-none py-3 text-white"
              data-testid="login-email"
            />
          </div>
          <div>
            <label className="overline block mb-2">Contraseña</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="w-full bg-transparent border-b border-white/20 focus:border-[#D97736] outline-none py-3 text-white"
              data-testid="login-password"
            />
          </div>
          {error && <div className="text-red-400 text-sm" data-testid="login-error">{error}</div>}
          <button
            type="submit"
            disabled={loading}
            className="w-full flex items-center justify-center gap-2 bg-[#D97736] hover:bg-[#E88D50] disabled:opacity-60 text-black font-semibold uppercase tracking-wide py-4 transition-colors"
            data-testid="login-submit"
          >
            <SignIn size={18} weight="bold" /> {loading ? "Entrando..." : "Entrar"}
          </button>
        </form>
      </div>
    </div>
  );
}
